import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {LogDeletedData} from "../interface/log-deleted-data";

@Injectable({
  providedIn: 'root'
})

export class LogDeletedDataService {
  private readonly LogDeletedDataListSubiect: ReplaySubject<CountedAndPaginated<LogDeletedData>> = new ReplaySubject<CountedAndPaginated<LogDeletedData>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(page: number, pageSize: number, filters: object,
                  sort?: { sortBy?: string, sortOrder?: string }): void {
    this.httpClient.get(`/rest/crm/log-deleted-data?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<LogDeletedData>) => {
        this.LogDeletedDataListSubiect.next(result);
      });
  }
  public getLogDeletedDataListSubject(): ReplaySubject<CountedAndPaginated<LogDeletedData>> {
    return this.LogDeletedDataListSubiect;
  }

  public restoreDeletedRecord(id: number): Observable<any> {
    return this.httpClient.post(`/rest/crm/log-deleted-data/${id}/restore`, null)
      .pipe(first());
  }

}
